import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "section booking-section" }
const _hoisted_2 = { class: "container booking-shell" }
const _hoisted_3 = { class: "booking-progress" }
const _hoisted_4 = {
  key: 0,
  class: "booking-panel"
}
const _hoisted_5 = { class: "panel-heading" }
const _hoisted_6 = { class: "choice-grid" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "booking-panel"
}
const _hoisted_9 = { class: "panel-heading" }
const _hoisted_10 = { class: "practitioner-row" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "date-row" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "time-grid" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "panel-heading" }
const _hoisted_17 = { class: "booking-summary" }
const _hoisted_18 = { class: "field-row" }
const _hoisted_19 = { class: "field-row" }
const _hoisted_20 = { class: "privacy-check" }
const _hoisted_21 = { class: "button primary booking-submit" }
const _hoisted_22 = {
  key: 3,
  class: "booking-success"
}
const _hoisted_23 = {
  key: 4,
  class: "booking-actions"
}
const _hoisted_24 = ["disabled"]

import {computed, ref} from 'vue';
import {
  ArrowLeft,
  ArrowRight,
  CalendarDays,
  CheckCircle2,
  Clock3,
  ShieldCheck,
  Stethoscope,
  UserRound
} from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'BookingView',
  setup(__props) {

const step = ref(1), treatment = ref(''), practitioner = ref(''), date = ref(''), time = ref('');
const patient = ref({firstName: '', lastName: '', email: '', phone: '', privacy: false})
const treatments = [['Kontrolluntersuchung', '20 Min.'], ['Professionelle Zahnreinigung', '60 Min.'], ['Beratung Zahnersatz', '30 Min.'], ['Akute Beschwerden', '20 Min.']];
const practitioners = ['Dr. Anna Weber', 'Dr. Jonas Neumann', 'Keine Präferenz'];
const dates = ['Mo, 10. Aug.', 'Di, 11. Aug.', 'Mi, 12. Aug.', 'Do, 13. Aug.', 'Fr, 14. Aug.'];
const times = ['08:30', '09:10', '10:20', '11:40', '14:10', '15:30', '16:20'];
const canContinue = computed(() => step.value === 1 ? !!treatment.value : !!practitioner.value && !!date.value && !!time.value)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[28] || (_cache[28] = _createElementVNode("section", { class: "page-hero" }, [
      _createElementVNode("div", { class: "container" }, [
        _createElementVNode("span", { class: "eyebrow" }, "Demo-Terminbuchung"),
        _createElementVNode("h1", null, [
          _createTextVNode("Ihr Termin."),
          _createElementVNode("br"),
          _createElementVNode("em", null, "Einfach online gebucht.")
        ]),
        _createElementVNode("p", null, "Diese interaktive Demo speichert und überträgt keine persönlichen Daten.")
      ])
    ], -1)),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
            return _createElementVNode("div", {
              key: n,
              class: _normalizeClass({active:step.value>=n})
            }, [
              _createElementVNode("span", null, _toDisplayString(step.value > n ? '✓' : n), 1),
              _createElementVNode("small", null, _toDisplayString(['Behandlung', 'Termin', 'Ihre Daten'][n - 1]), 1)
            ], 2)
          }), 64))
        ]),
        (step.value===1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(Stethoscope)),
                _cache[8] || (_cache[8] = _createElementVNode("div", null, [
                  _createElementVNode("h2", null, "Was können wir für Sie tun?"),
                  _createElementVNode("p", null, "Wählen Sie einen Besuchsgrund.")
                ], -1))
              ]),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(treatments, (item) => {
                  return _createElementVNode("button", {
                    key: item[0],
                    class: _normalizeClass({selected:treatment.value===item[0]}),
                    onClick: ($event: any) => (treatment.value=item[0])
                  }, [
                    _createElementVNode("strong", null, _toDisplayString(item[0]), 1),
                    _createElementVNode("em", null, _toDisplayString(item[1]), 1)
                  ], 10, _hoisted_7)
                }), 64))
              ])
            ]))
          : (step.value===2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_unref(CalendarDays)),
                  _cache[9] || (_cache[9] = _createElementVNode("div", null, [
                    _createElementVNode("h2", null, "Wann passt es Ihnen?"),
                    _createElementVNode("p", null, "Alle Zeiten sind fiktive Demo-Termine.")
                  ], -1))
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "booking-label" }, "Behandler", -1)),
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(practitioners, (p) => {
                    return _createElementVNode("button", {
                      key: p,
                      class: _normalizeClass({selected:practitioner.value===p}),
                      onClick: ($event: any) => (practitioner.value=p)
                    }, [
                      _createVNode(_unref(UserRound)),
                      _createTextVNode(" " + _toDisplayString(p), 1)
                    ], 10, _hoisted_11)
                  }), 64))
                ]),
                _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "booking-label" }, "Tag", -1)),
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(dates, (d) => {
                    return _createElementVNode("button", {
                      key: d,
                      class: _normalizeClass({selected:date.value===d}),
                      onClick: ($event: any) => (date.value=d)
                    }, _toDisplayString(d), 11, _hoisted_13)
                  }), 64))
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "booking-label" }, "Uhrzeit", -1)),
                _createElementVNode("div", _hoisted_14, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(times, (t) => {
                    return _createElementVNode("button", {
                      key: t,
                      class: _normalizeClass({selected:time.value===t}),
                      onClick: ($event: any) => (time.value=t)
                    }, [
                      _createVNode(_unref(Clock3)),
                      _createTextVNode(" " + _toDisplayString(t), 1)
                    ], 10, _hoisted_15)
                  }), 64))
                ])
              ]))
            : (step.value===3)
              ? (_openBlock(), _createElementBlock("form", {
                  key: 2,
                  class: "booking-panel",
                  onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (step.value=4), ["prevent"]))
                }, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_unref(UserRound)),
                    _cache[13] || (_cache[13] = _createElementVNode("div", null, [
                      _createElementVNode("h2", null, "Fast geschafft"),
                      _createElementVNode("p", null, "Ergänzen Sie Ihre Kontaktdaten.")
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", null, [
                      _cache[14] || (_cache[14] = _createElementVNode("small", null, "Behandlung", -1)),
                      _createElementVNode("strong", null, _toDisplayString(treatment.value), 1)
                    ]),
                    _createElementVNode("span", null, [
                      _cache[15] || (_cache[15] = _createElementVNode("small", null, "Termin", -1)),
                      _createElementVNode("strong", null, _toDisplayString(date.value) + " · " + _toDisplayString(time.value), 1)
                    ]),
                    _createElementVNode("span", null, [
                      _cache[16] || (_cache[16] = _createElementVNode("small", null, "Behandler", -1)),
                      _createElementVNode("strong", null, _toDisplayString(practitioner.value), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("label", null, [
                      _cache[17] || (_cache[17] = _createElementVNode("span", null, "Vorname *", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((patient.value.firstName) = $event)),
                        required: ""
                      }, null, 512), [
                        [_vModelText, patient.value.firstName]
                      ])
                    ]),
                    _createElementVNode("label", null, [
                      _cache[18] || (_cache[18] = _createElementVNode("span", null, "Nachname *", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((patient.value.lastName) = $event)),
                        required: ""
                      }, null, 512), [
                        [_vModelText, patient.value.lastName]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("label", null, [
                      _cache[19] || (_cache[19] = _createElementVNode("span", null, "E-Mail *", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((patient.value.email) = $event)),
                        required: "",
                        type: "email"
                      }, null, 512), [
                        [_vModelText, patient.value.email]
                      ])
                    ]),
                    _createElementVNode("label", null, [
                      _cache[20] || (_cache[20] = _createElementVNode("span", null, "Telefon *", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((patient.value.phone) = $event)),
                        required: "",
                        type: "tel"
                      }, null, 512), [
                        [_vModelText, patient.value.phone]
                      ])
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_20, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((patient.value.privacy) = $event)),
                      required: "",
                      type: "checkbox"
                    }, null, 512), [
                      [_vModelCheckbox, patient.value.privacy]
                    ]),
                    _cache[21] || (_cache[21] = _createElementVNode("span", null, "Ich akzeptiere die Demo-Datenschutzhinweise.", -1))
                  ]),
                  _createElementVNode("button", _hoisted_21, [
                    _createVNode(_unref(ShieldCheck)),
                    _cache[22] || (_cache[22] = _createTextVNode(" Demo-Termin bestätigen ", -1))
                  ])
                ], 32))
              : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createVNode(_unref(CheckCircle2)),
                  _cache[24] || (_cache[24] = _createElementVNode("h2", null, "Termin erfolgreich vorgemerkt", -1)),
                  _cache[25] || (_cache[25] = _createElementVNode("p", null, "In einer echten Integration würde dieser Termin nun im Praxiskalender erscheinen und automatisch bestätigt werden.", -1)),
                  _createVNode(_component_router_link, {
                    to: "/",
                    class: "button primary"
                  }, {
                    default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                      _createTextVNode("Zur Startseite", -1)
                    ]))]),
                    _: 1
                  })
                ])),
        (step.value<3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              (step.value>1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "back-button",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (step.value--))
                  }, [
                    _createVNode(_unref(ArrowLeft)),
                    _cache[26] || (_cache[26] = _createTextVNode(" Zurück ", -1))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "button primary",
                disabled: !canContinue.value,
                onClick: _cache[7] || (_cache[7] = ($event: any) => (step.value++))
              }, [
                _cache[27] || (_cache[27] = _createTextVNode("Weiter ", -1)),
                _createVNode(_unref(ArrowRight))
              ], 8, _hoisted_24)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})